export const getters = {
    isLoading: state => state.loading,
    pageTitle: state => state.pageTitle,
    breadcrumb: state => state.breadcrumb,
    closeSidebar: state => state.closeSidebar,
    getNazioni: state => state.nazioni,
    getProvincie: state => state.provincie
};
